/**
 * workflowContainerMemo.ts — Workflow 容器 memo 比较（DES-3）
 */
import type { WorkflowContainerRuntimeNode } from '../../types/workflowContainer';
import type { WorkflowDisplayPayload } from '../../types/workflowDisplay';

function displayVisualEqual(
  a: WorkflowDisplayPayload | null,
  b: WorkflowDisplayPayload | null,
): boolean {
  if (a === b) return true;
  if (a === null || b === null) return false;
  if (a.progress_current !== b.progress_current) return false;
  if (a.status !== b.status) return false;
  return true;
}

export function workflowContainerNodeVisualEqual(
  a: WorkflowContainerRuntimeNode,
  b: WorkflowContainerRuntimeNode,
): boolean {
  if (a.container_id !== b.container_id) return false;
  if (a.status !== b.status) return false;
  if (a.is_open !== b.is_open) return false;
  if (a.loopSessionId !== b.loopSessionId) return false;
  if (a.title !== b.title) return false;
  if (a.subtitle !== b.subtitle) return false;
  if (a.content_blocks.length !== b.content_blocks.length) return false;
  if (!displayVisualEqual(a.display, b.display)) return false;
  return true;
}

export interface WorkflowContainerViewProps {
  depth?: number;
  virtualized?: boolean;
  virtualizeThreshold?: number;
  groupParallelTools?: boolean;
}

export function workflowContainerViewPropsEqual(
  prev: WorkflowContainerViewProps,
  next: WorkflowContainerViewProps,
): boolean {
  return (
    prev.depth === next.depth
    && prev.virtualized === next.virtualized
    && prev.virtualizeThreshold === next.virtualizeThreshold
    && prev.groupParallelTools === next.groupParallelTools
  );
}
